// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"checkbox_checkboxWrapper__e1pD4","disabled":"checkbox_disabled__lLe3E","active":"checkbox_active__7cyaV"};